/**
 * ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
 * Bangalore, India. All Rights Reserved.
 */
import {
    PolymerElement,
    html
} from "@polymer/polymer/polymer-element.js";
import {
    mixinBehaviors
} from "@polymer/polymer/lib/legacy/class.js";
import "../../sb_account_ui/elements/account-selection.js";
import "../behaviors/alias-management-behavior.js";
import "../elements/app-success-animation.js";
class PayAliasSuccess extends mixinBehaviors([accessibilityBehaviours.commonFunctions, sbBehaviours.aliasManagementBehavior, sbBehaviours.authAndSubmit], PolymerElement) {
    /** Properties definition*/
    static get properties() {
            return {
                /** This property holds the alias management selected iron page. */
                selectedPage: {
                    type: Number,
                    notify: true
                        //observer:'successMsgDisplay'
                },
                /** This property holds the profile page selected iron page. */
                myprofilepagenumber: {
                    type: Number,
                    notify: true
                },
                /** This property holds the alias management txn date. */
                txnDate: {
                    type: String,
                    notify: true
                },
                /** This property holds the alias management api success response. */
                successResponse: {
                    type: Object,
                    notify: true,
                    observer: '_assignDetails'
                },
                /** This property holds the alias id. */
                aliasId: {
                    type: String,
                    notify: true
                },
                /** This property holds the alias Type. */
                aliasType: {
                    type: String,
                    notify: true
                },
                /** This property holds the alias apis referenceId. */
                referenceId: {
                    type: String,
                    notify: true
                },
                /** This property holds the alias management successMessage. */
                successMsg: {
                    type: String,
                    notify: true
                },
                /** This property holds the alias management selected account ID. */
                selectedAccId: {
                    type: String,
                    notify: true
                }
            };
        }
        /** HTML template definition*/


    static get template() {
        return html `
        <style include="app-styles">
            .margin-top-20px {
                margin-top: 20px;
            }
            app-dialog {
                --dialog-background-color: {
                    background-color: var(--brand-color);
                }
            }
  
            app-dialog {
                --dialog-text-color: {
                    color: var(--background-primary);
                }
            }
            .iron-icon-color {
                color: var(--brand-color);
            }

            app-swiper {
                --app-swipe-height: {
                    overflow: visible;
                    height: 90px;
                }
              }
              
              .more-button[isiosandroiddevice], .action-close-button[isiosandroiddevice] {
                display: none;
              }
              app-drop-down {
                --app-drop-down-color: {
                   color: var(--secondary-light-color)
                     };
             }
             app-drop-down {
                --icon-custom-style: {
                   color: #000
                     };
             }
             .accStyle{
                 margin-left:16px;
             }
             .success-parent-container {
				padding-top: 42px;
				padding-left: 16px;
				padding-right: 16px;
			      }
			      .outlineOffset:focus{
			      outline:2px solid #0075da;
			      outline-offset:5px
			    }
        </style>   
        <app-media-query desktop="{{desktop}}" tablet="{{tablet}}" phone="{{phone}}"></app-media-query>     
        <app-success-page page-selected=true callback="{{callback}}">
    <div id="open-app-success"  class="background-primary success-parent-container">
    <page-title name="" paper-toolbar-back-color="var(--background-primary)" paper-toolbar-text-color="var(--primary-dark-color)" left-action="" right-action="{{rightAction}}"></page-title>
    <template is="dom-if" if="{{!phone}}">
    <paper-card  class="light-background border-dynamic shadow" phone$="{{phone}}" tablet$="{{tablet}}" desktop$="{{desktop}}">
            <div on-keydown="removeTabindex">
			<div class="mdl-grid--no-spacing  success-icon">
			<div class="margin-l-zero mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop text-align-center ">
				<iron-icon class="success-icon-m icon-background" name="successtick" icon="successtick"></iron-icon>
			</div>
		</div>

                <div class="mdl-grid padding-lr-zero">
                    <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop  text-align-center margin-b-zero">
                        <oe-i18n-msg role="heading" aria-describedby="descMessage" id="success_focus" on-blur="removeFocus" class="outlineOffset primary-dark-text-xl" msgid="l_Success"></oe-i18n-msg>

                    </div>
                    <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop  text-align-center margin-b-zero">
                        <oe-i18n-msg class="secondary-dark-text-s" msgid="{{successMsg}}"></oe-i18n-msg>
					</div>
					<div class="border-b-1px mdl-cell mdl-cell--12-col">
					</div>
					
                </div>
                <div role="grid" class="full-width">
                    <div class="outlineAddsOffset mdl-grid" role="row" tabindex="0" on-keydown="_toEditCategoryEnterKeyWithTab" on-focusout="onFocusoutCategory" aria-describedby="_selectedCategoryDescription">
                        <div role="cell" class="mdl-cell mdl-cell--12-col mdl-cell--4-col-phone mdl-cell--3-col-tablet mdl-cell--4-col-desktop">
                            <div class="secondary-dark-text-m content-align-left margin-top-20px" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}">
                                <oe-i18n-msg msgid="{{aliasType}}"></oe-i18n-msg>: {{aliasId}}
                            </div>
                            <div class="secondary-dark-text-m content-align-left margin-top-20px" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}">
                                <oe-i18n-msg msgid="Savings"></oe-i18n-msg>
                                <oe-i18n-msg msgid="{{selectedAccId}}"></oe-i18n-msg>
                            </div>
                        </div>
                        <div role="cell" class="mdl-cell mdl-cell--12-col mdl-cell--4-col-phone mdl-cell--3-col-tablet mdl-cell--4-col-desktop">
                        </div>
                        <div role="cell" class="mdl-cell mdl-cell--12-col mdl-cell--4-col-phone mdl-cell--3-col-tablet mdl-cell--4-col-desktop">
                            <div class="secondary-dark-text-m content-align-right margin-top-20px" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}">
                                <oe-i18n-msg msgid="{{txnDate}}"></oe-i18n-msg>
                            </div>
                            <div class="secondary-dark-text-m content-align-right margin-top-20px" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}">
                                <oe-i18n-msg msgid="l_TransactionId"></oe-i18n-msg>: {{referenceId}}
                            </div>
                        </div>
					</div>
				</div>
				<div class="border-b-1px mdl-cell mdl-cell--12-col">
        </div>
        <div class="mdl-grid mdl-cell mdl-cell--12-col">
        </div>
            </div>
    </paper-card>
    </template>
    <template is="dom-if" if="{{phone}}">
    <paper-card  class="light-background border-dynamic shadow" phone$="{{phone}}" tablet$="{{tablet}}" desktop$="{{desktop}}">
            <app-success-animation></app-success-animation>
            <div on-keydown="removeTabindex">
			<div class="mdl-grid--no-spacing  success-icon">
			<div class="margin-l-zero mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop text-align-center ">
				<iron-icon class="success-icon-m icon-background" name="successtick" icon="successtick"></iron-icon>
			</div>
		</div>

                <div class="mdl-grid padding-lr-zero">
                    <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop  text-align-center margin-b-zero">
                        <oe-i18n-msg role="heading" aria-describedby="descMessage" id="success_focus" on-blur="removeFocus" class="outlineOffset primary-dark-text-xl" msgid="l_Success"></oe-i18n-msg>

                    </div>
                    <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop  text-align-center margin-b-zero">
                        <oe-i18n-msg class="secondary-dark-text-s" msgid="{{successMsg}}"></oe-i18n-msg>
					</div>
					<div class="border-b-1px mdl-cell mdl-cell--12-col">
					</div>
					
                </div>
                <div role="grid" class="full-width payment-details">
                    <div class="outlineAddsOffset mdl-grid" role="row" tabindex="0" on-keydown="_toEditCategoryEnterKeyWithTab" on-focusout="onFocusoutCategory" aria-describedby="_selectedCategoryDescription">
                        <div role="cell" class="mdl-cell mdl-cell--12-col mdl-cell--4-col-phone mdl-cell--3-col-tablet mdl-cell--4-col-desktop">
                            <div class="secondary-dark-text-m content-align-left margin-top-20px" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}">
                                <oe-i18n-msg msgid="{{aliasType}}"></oe-i18n-msg>: {{aliasId}}
                            </div>
                            <div class="secondary-dark-text-m content-align-left margin-top-20px" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}">
                                <oe-i18n-msg msgid="Savings"></oe-i18n-msg>
                                <oe-i18n-msg msgid="{{selectedAccId}}"></oe-i18n-msg>
                            </div>
                        </div>
                        <div role="cell" class="mdl-cell mdl-cell--12-col mdl-cell--4-col-phone mdl-cell--3-col-tablet mdl-cell--4-col-desktop">
                        </div>
                        <div role="cell" class="mdl-cell mdl-cell--12-col mdl-cell--4-col-phone mdl-cell--3-col-tablet mdl-cell--4-col-desktop">
                            <div class="secondary-dark-text-m content-align-right margin-top-20px" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}">
                                <oe-i18n-msg msgid="{{txnDate}}"></oe-i18n-msg>
                            </div>
                            <div class="secondary-dark-text-m content-align-right margin-top-20px" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}">
                                <oe-i18n-msg msgid="l_TransactionId"></oe-i18n-msg>: {{referenceId}}
                            </div>
                        </div>
					</div>
				</div>
				<div class="border-b-1px mdl-cell mdl-cell--12-col">
        </div>
        <div class="mdl-grid mdl-cell mdl-cell--12-col">
        </div>
            </div>
    </paper-card>
    </template>
</app-success-page>
                 
      `;
    }

    connectedCallback() {
        super.connectedCallback();
        var date = getNewDate();
        this.txnDate = this.formatDate(date);
        this.callback = this._onCloseClick.bind(this);
    }

    /*event fired to assign alias api success details*/
    _assignDetails() {
        this.aliasId = this.successResponse.alias;
        this.aliasType = this.successResponse.aliasType.codeDescription;
        this.referenceId = this.successResponse.referenceId

    }

    /*event fired for formatting date*/
    formatDate(date) {
        return moment(date).format(clientStorage.get(storageType.session, 'dateFormat') + " h:mma");
    }


    /*event fired for closing success page in mobile device*/
    _onCloseClick() {
        window.oe_navigate_to("/", {});
    }

}

customElements.define('pay-alias-success', PayAliasSuccess);